mobileSize = 1000;
function countdownBanner() {
  if ($('body').hasClass('saffireMobileSize')) {
      $('#siteInfoBannerWidget').insertAfter('.header-bottom');
  } else {
      $('#siteInfoBannerWidget').insertBefore('.header-logo');
  }
}

$(document).ready(function(){
  $(".socialNetworks").insertAfter(".mobile-menu-footer-links");
  countdownBanner();
   // General Message
   $('.generalmessage').prependTo('.header');
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1000) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1001) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
  
});

$(window).load(function(){
  
	$('body').addClass('pageIsLoaded');
  countdownBanner();
});
$(window).resize(function(){
  countdownBanner();
});